const CONFIG = {
  "metadata": {
    "version": "2026.02.20",
    "name": "Street Vendor Intake Form",
    "description": "This is a recurrent survey that is asked on every house visit (roughly every 20 days), but only to the street vendors. It is administered after the global perceptual survey for all participants"
  },
  "structure": [
    {
      "id": "primary_item_sold",
      "type": "multiple_choice",
      "answer_type": "string",
      "include_other": true,
      "title": "Primary Item Sold",
      "infoText": "What is the primary item you sell at your business?",
      "options": [
        "Produce (fruits and vegetables)",
        "Cloth, clothes, clothing utensils, etc.",
        "Cutlery",
        "Flowers",
        "Murti",
        "Fish"
      ],
      "include_na": false,
      "translation": {
        "es": {
          "title": "Artículo principal de venta",
          "infoText": "¿Cuál es el artículo principal que vende en su negocio?",
          "options": [
            "Productos agrícolas (frutas y verduras)",
            "Telas, ropa, accesorios de vestir, etc.",
            "Cubiertos",
            "Flores",
            "Murti",
            "Pescado"
          ]
        },
        "gu": {
          "options": [
            "શાકભાજી અને ફળ",
            "કપડાં, વસ્ત્રો, ઘરગથ્થુ વાસણો વગેરે",
            "કટલરી (ચમચા, કાંટા, પ્લેટ વગેરે)",
            "ફૂલો",
            "મૂર્તિ",
            "માછલી"
          ],
          "title": "મુખ્ય વેચાણ વસ્તુ",
          "infoText": "તમારા વ્યવસાયમાં તમે મુખ્ય રીતે શું વેચો છો?"
        },
        "hi": {
          "options": [
            "फल और सब्ज़ियाँ",
            "कपड़ा / कपड़े / बर्तन आदि",
            "कटलरी / चम्मच-कांटा / खाने के बर्तन",
            "फूल",
            "मूर्ति",
            "मछली"
          ],
          "title": "मुख्य रूप से बेचा जाने वाला सामान",
          "infoText": "आप अपने व्यापार में मुख्य रूप से कौन-सा सामान बेचते हैं?"
        }
      }
    },
    {
      "id": "other_items_sold",
      "type": "multiple_choice_answer",
      "include_other": true,
      "title": "Other Items Sold",
      "infoText": "Do you sometimes sell any other items? Check all that apply.",
      "options": [
        "Produce (fruits and vegetables)",
        "Cloth, clothes, clothing utensils, etc.",
        "Cutlery",
        "Flowers",
        "Murti",
        "Fish"
      ],
      "include_na": false,
      "translation": {
        "es": {
          "title": "Otros artículos de venta",
          "infoText": "¿Vende a veces otros artículos? Seleccione todos los que correspondan.",
          "options": [
            "Productos agrícolas (frutas y verduras)",
            "Telas, ropa, accesorios de vestir, etc.",
            "Cubiertos",
            "Flores",
            "Murti",
            "Pescado"
          ]
        },
        "gu": {
          "options": [
            "શાકભાજી અને ફળ",
            "કપડાં, વસ્ત્રો, ઘરગથ્થુ વાસણો વગેરે",
            "કટલરી (ચમચા, કાંટા, પ્લેટ વગેરે)",
            "ફૂલો",
            "મૂર્તિ",
            "માછલી"
          ],
          "title": "અન્ય વેચાતી વસ્તુઓ",
          "infoText": "શું તમે ક્યારેક બીજી વસ્તુઓ પણ વેચો છો? લાગુ પડે તે બધા પસંદ કરો:"
        },
        "hi": {
          "options": [
            "फल और सब्ज़ियाँ",
            "कपड़ा / कपड़े / बर्तन आदि",
            "कटलरी / चम्मच-कांटा / खाने के बर्तन",
            "फूल",
            "मूर्ति",
            "मछली"
          ],
          "title": "अन्य सामान जो बेचे जाते हैं",
          "infoText": "क्या आप कभी-कभी और भी कोई सामान बेचते हैं? जो लागू हो, उन पर टिक करें:"
        }
      }
    },
    {
      "id": "heat_protection_strategies",
      "type": "multiple_choice_answer",
      "include_other": true,
      "title": "Heat Protection Strategies",
      "infoText": "Which of the following strategies does the participant use to protect their business and/or themselves when it gets hot? Check all that apply.",
      "options": [
        "Start work earlier in the morning",
        "Stop work or close my business during the hottest part of the day",
        "End work later in the night",
        "Take more frequent breaks while working",
        "Work fewer hours",
        "Reduce the amount of stock displayed",
        "Shift to selling items less affected by heat",
        "Store stock in a cold place (e.g., cooler, ice box)",
        "Sprinkle water on the ground around worksite",
        "Sprinkle water on produce / items being sold",
        "Seek shade for myself (e.g., using umbrella, tarp, tree)",
        "Use shade to protect my produce or stock",
        "Drink more water, lime water, buttermilk, aam-panna etc.",
        "Use a fan (e.g., handheld, electric)",
        "Splash water on face and skin",
        "Change or remove clothes"
      ],
      "include_na": false,
      "translation": {
        "es": {
          "title": "Estrategias de protección contra el calor",
          "infoText": "¿Cuáles de las siguientes estrategias utiliza la participante para proteger su negocio y/o a sí misma cuando hace calor? Seleccione todas las que correspondan.",
          "options": [
            "Comenzar a trabajar más temprano en la mañana",
            "Dejar de trabajar o cerrar mi negocio durante la parte más calurosa del día",
            "Terminar de trabajar más tarde en la noche",
            "Tomar descansos más frecuentes mientras trabaja",
            "Trabajar menos horas",
            "Reducir la cantidad de mercancía exhibida",
            "Cambiar a vender artículos menos afectados por el calor",
            "Almacenar la mercancía en un lugar frío (por ejemplo, nevera, caja de hielo)",
            "Rociar agua en el suelo alrededor del lugar de trabajo",
            "Rociar agua sobre los productos/artículos en venta",
            "Buscar sombra para mí misma (por ejemplo, usando sombrilla, lona, árbol)",
            "Usar sombra para proteger mis productos o mercancía",
            "Beber más agua, agua con limón, suero de leche, aam-panna, etc.",
            "Usar un ventilador (por ejemplo, de mano, eléctrico)",
            "Echarse agua en la cara y la piel",
            "Cambiarse o quitarse ropa"
          ]
        },
        "gu": {
          "options": [
            "સવારે વહેલું કામ શરૂ કરું છું",
            "દિવસના સૌથી ગરમ સમયે કામ બંધ કરું છું / દુકાન બંધ રાખું છું",
            "રાત્રે મોડું સુધી કામ કરું છું",
            "કામ દરમિયાન વધુ વખત વિરામ લઉં છું",
            "ઓછા કલાક કામ કરું છું",
            "જરૂર જેટલો જ માલ બહાર મૂકવો",
            "ગરમીથી ઓછી અસર પામે એવી વસ્તુઓ વેચવા તરફ વળું છું",
            "સ્ટોક ઠંડા સ્થળે રાખું છું (જેમ કે કૂલર, આઇસ બોક્સ)",
            "કામની જગ્યાની આસપાસ જમીન પર પાણી છાંટું છું",
            "વેચાતી વસ્તુઓ / શાકભાજી પર પાણી છાંટું છું",
            "પોતાને છાંયો મળે એવી વ્યવસ્થા કરું છું (જેમ કે છત્રી, તાડપત્રી, ઝાડની છાંય)",
            "સ્ટોક અથવા માલને છાંયામાં રાખું છું",
            "વધુ પાણી, લીંબુ પાણી, છાશ, આમ પન્ના વગેરે પીવું",
            "પંખો વાપરું છું (હાથમાં પકડવાનો અથવા વીજળીથી ચાલતો પંખો)",
            "ચહેરા અને શરીર પર પાણી છાંટું છું",
            "કપડાં બદલું છું અથવા હલકા કપડાં પહેરું છું"
          ],
          "title": "ગરમીથી બચાવના ઉપાયો",
          "infoText": "ગરમીમાં પોતાનો વ્યવસાય અને/અથવા પોતાનું રક્ષણ કરવા માટે બહેનો  નીચેના પૈકી કયા ઉપાયો કરે છે? લાગુ પડે તે બધા પસંદ કરો."
        },
        "hi": {
          "options": [
            "सुबह जल्दी काम शुरू करना",
            "दिन के सबसे ज्यादा गर्म समय में काम बंद करना / दुकान बंद करना",
            "रात में देर तक काम करना",
            "काम करते समय ज्यादा बार आराम लेना",
            "कम घंटे काम करना",
            "दुकान में कम सामान बाहर रखना",
            "ऐसे सामान बेचना जो गर्मी से कम खराब होते हों",
            "सामान को ठंडी जगह पर रखना (जैसे कूलर, आइस बॉक्स)",
            "काम की जगह के आसपास जमीन पर पानी छिड़कना",
            "बिकने वाले सामान/सब्ज़ियों पर पानी छिड़कना",
            "खुद के लिए छांव का इंतज़ाम करना (जैसे छाता, तिरपाल, पेड़ की छांव)",
            "सामान/स्टॉक को छांव में रखना",
            "ज्यादा पानी, नींबू पानी, छाछ, आम पन्ना आदि पीना",
            "पंखे का इस्तेमाल करना (हाथ वाला या बिजली वाला पंखा)",
            "चेहरे और शरीर पर पानी डालना",
            "कपड़े बदलना या हल्के कपड़े पहनना"
          ],
          "title": "गर्मी से बचाव के तरीके",
          "infoText": "गर्मी के समय व्यापार और/या खुद को सुरक्षित रखने के लिए बहनें कौन-कौन से तरीके अपनाती है? जो भी लागू हों, सभी चुनें:"
        }
      }
    },
    {
      "id": "work_location_photo",
      "type": "image_upload",
      "title": "Work Location Photo",
      "infoText": "Upload a picture of the vendor's primary work location. Try to get as much of the stall/work area in the picture as possible.",
      "include_na": true,
      "translation": {
        "es": {
          "title": "Foto del lugar de trabajo",
          "infoText": "Suba una foto del lugar de trabajo principal del vendedor. Intente capturar la mayor parte del puesto/área de trabajo posible."
        },
        "gu": {
          "title": "કામની જગ્યા નો ફોટો",
          "infoText": "બહેનની મુખ્ય કામ કરવાની જગ્યાનો ફોટો અપલોડ કરો. શક્ય તેટલું સ્ટોલ/કામની જગ્યા સ્પષ્ટ દેખાય એવો ફોટો લો."
        },
        "hi": {
          "title": "काम की जगह की फोटो",
          "infoText": "बहन की मुख्य काम करने की जगह की फोटो अपलोड करें। कोशिश करें कि स्टॉल/काम करने की जगह ज्यादा से ज्यादा साफ दिखाई दे।"
        }
      }
    },
    {
      "id": "stock_photo",
      "type": "image_upload",
      "title": "Stock Photo",
      "infoText": "Upload a picture of what the participant is selling.",
      "include_na": true,
      "translation": {
        "es": {
          "title": "Foto de la mercancía",
          "infoText": "Suba una foto de lo que la participante está vendiendo."
        },
        "gu": {
          "title": "સ્ટોક નો ફોટો",
          "infoText": "બહેન જે વસ્તુ વેચે છે તેનો ફોટો અપલોડ કરો."
        },
        "hi": {
          "title": "बेचे जा रहे सामान की फोटो",
          "infoText": "बहन जो सामान बेच रहा/रही है उसकी फोटो अपलोड करें।"
        }
      }
    }
  ]
} 
export default CONFIG